import List from "@/components/list";
import store from "@/store";
import { getItem } from "@/utils/storage";
import route from "@/router";
/*
 *  超级管理员可以修改readony=1的数据，其他角色不可以，有新增权限才可以操作
 */

const Table = args => {
  const { listeners } = args;
  const selectRole = listeners["selectRole"] || function() {};
  const selectDept = listeners["selectDept"] || function() {};
  const deletePermission = listeners["deletePermission"] || function() {};
  const AccountTableConfig = [
    {
      label: "所属学院",
      prop: "topDeptName",
      render: e => {
        const item = e.row;
        return <el-input size="small" value={item.topDeptName} placeholder="请先选择管理组织" disabled title={item.deptName}></el-input>
      }
    },
    {
      label: "管理组织",
      prop: "deptName",
      render: e => {
        const item = e.row;
        if (item.readonly == 1 && getItem("userType") != -1) {
          return (
            <el-input size="small" value={item.deptName} disabled title={item.deptName}></el-input>
          );
        } else {
          return (
            <el-select
              size="small"
              placeholder="请选择管理组织"
              value={item.deptName}
              title={item.deptName}
              popper-append-to-body={false}
              onFocus={function (event) {
                // 阻止默认事件
                if (event && event.preventDefault) {
                  event.preventDefault();
                }
                // IE阻止默认事件
                if (window.event) {
                  event.returnValue = false;
                }
                selectDept(e.$index);
              }}
            >
              <span slot="empty" style="display:none"></span>
            </el-select>
          );
        }
      }
    },
    {
      label: "角色",
      prop: "roleName",
      render: e => {
        const item = e.row;
        return item.readonly == 1 && getItem("userType") != -1 ? (
          <el-input size="small" value={item.roleName} disabled title={item.roleName} />
        ) : (
          <el-select
            disabled={!item.deptId}
            value={item.roleId}
            title={item.roleName}
            onChange={val => {
              let roleName;
              for (const ele of item.roles) {
                if (ele.uuid === val) {
                  roleName = ele.roleName;
                  selectRole(roleName, val, e.$index);
                  return;
                }
              }
            }}
            placeholder="请选择角色"
            size="small"
          >
            {item.roles.map(ele => {
              return (
                <el-option
                  key={ele.uuid}
                  label={ele.roleName}
                  value={ele.uuid}
                ></el-option>
              );
            })}
          </el-select>
        );
      }
    }
  ];
  const routerName = route.currentRoute.name.split("/")[0];
  const permissionList = store.getters.permissionList[routerName];
  if (permissionList && permissionList.includes("user:permissionSave")) {
    AccountTableConfig.push({
      label: "操作",
      prop: "positionLevel",
      width: '80',
      render: e => {
        const item = e.row;
        const readonly = item.readonly == 1 && getItem("userType") != -1;
        return (
          <el-tooltip content="删除" placement="top">
            <i
              class={readonly ? "icon-delete-disable" : "icon-delete"}
              onClick={() => {
                !readonly && deletePermission(e.$index);
              }}
            ></i>
          </el-tooltip>
        );
      }
    });
  }

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
